export enum StatusInscricao {
  PENDENTE = 'PENDENTE',
  CONFIRMADA = 'CONFIRMADA',
  CANCELADA = 'CANCELADA',
  FILA_ESPERA = 'FILA_ESPERA'
}

export interface InscritoAtleta {
  id: string;
  nome: string;
  username: string;
  imagemUrl?: string | null;
  cidade?: string | null;
  status?: string | null;
  equipeId?: string | null;
  inscricaoId?: string | null;
}

